import { Button, Flex, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import Textarea from "../inputs/Textarea";
import PrimaryButton from "../PrimaryButton";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import Input from "../inputs/Input";

type HaltOrderFormProps = {
	id: number;
	onSubmit?: (data: {
		status: string;
		explanation: string;
		reason: string;
	}) => void;
	onClose?: () => void;
};

const haltSchema = z.object({
	explanation: z.string().min(1, { message: "Ce champ est requis." }),
});

function HaltOrderForm({ id, onSubmit, onClose }: HaltOrderFormProps) {
	const methods = useForm({
		resolver: zodResolver(haltSchema),
	});

	const resetFormFields = async () => {
		methods.reset({
			explanation: "",
		});
	};
	const handleSubmit = async () => {
		const valid = await methods.trigger();
		if (valid && onSubmit) {
			const { explanation } = methods.getValues();
			onSubmit({
				status: "modification",
				explanation,
				reason: "modification",
			});
			resetFormFields();
		}
	};
	return (
		<FormProvider {...methods}>
			<form style={{ marginTop: "32px", marginBottom: "32px" }}>
				<FormControl>
					<Input
						id="id"
						placeholder="N° de commande"
						name="id"
						isDisabled={true}
						defaultValue={id}
					></Input>
				</FormControl>
				<FormControl isInvalid={!!methods.formState.errors.explanation}>
					<Textarea
						id="explanation"
						placeholder="Explication"
						mt={4}
						{...methods.register("explanation")}
					></Textarea>
					<FormErrorMessage>
						<>{methods.formState.errors?.explanation?.message}</>
					</FormErrorMessage>
				</FormControl>

				<Flex mt={3} pt={3} justifyContent={"end"} w="100%">
					<Button w={"fit-content"} mr={4} onClick={onClose}>
						Annuler
					</Button>
					<PrimaryButton w={"fit-content"} onClick={handleSubmit}>
						Valider
					</PrimaryButton>
				</Flex>
			</form>
		</FormProvider>
	);
}

export default HaltOrderForm;
